import { SHOPIFY_PAGE_ID_PREFIX } from '../constants';
import { TemplateType } from '~/types/template';

export const getShopifyPageId = ({ type, id }: { type?: string; id: string }) => {
  switch (type) {
    case TemplateType.PRODUCT:
      return `${SHOPIFY_PAGE_ID_PREFIX}Product/${id}`;
    case TemplateType.COLLECTION:
      return `${SHOPIFY_PAGE_ID_PREFIX}Collection/${id}`;
    case TemplateType.ARTICLE:
      return `${SHOPIFY_PAGE_ID_PREFIX}Article/${id}`;
    case TemplateType.PAGE:
      return `${SHOPIFY_PAGE_ID_PREFIX}Page/${id}`;
    default:
      return null;
  }
};

export interface IShopifyPageLinkParams {
  handle?: string | null;
  type?: TemplateType;
  blogHandle?: string | null;
}

export const getShopifyPageLink = ({
  handle,
  type,
  blogHandle,
}: IShopifyPageLinkParams): string | null => {
  if (type === TemplateType.HOME) return `/`;
  if (!handle) return null;

  switch (type) {
    case TemplateType.PRODUCT:
      return `/products/${handle}`;
    case TemplateType.COLLECTION:
      return `/collections/${handle}`;
    case TemplateType.ARTICLE:
      return blogHandle ? `/blogs/${blogHandle}/${handle}` : null;
    case TemplateType.PAGE:
      return `/pages/${handle}`;
    default:
      return null;
  }
};
